module.exports = __webpack_public_path__ + "img/ape_arrow.b40d5feb.png";